import instance from '../plugins/request'

export const getUser=()=>{return instance({method:'POST',url:'/getuser.php',data:{platform:'getuser'}})}

